<template>
  <svg alt="" :class="`icon ${name}`">
    <use :xlink:href="`#${name}`"></use>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    name: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  height: 20px;
  width: 20px;
  fill: #565656;
  margin-right: 12px;
}
</style>
